import React, { FC, PropsWithChildren } from "react";

interface Props {
    noSidebar?: boolean;
}

export const InfoSection: FC<PropsWithChildren<Props>> = ({ children, noSidebar }) => {
    return (
        <div
            className={`my-12 flex w-full flex-col justify-center space-y-12 sm:mb-20 ${
                noSidebar ? "" : "xl:items-end"
            }`}
        >
            {children}
        </div>
    );
};
